import React, { useState, useCallback } from "react";
import Modal, { Header, Content } from "_c/Modals";
import { useToggle } from "@/hooks/useToggle";
import { CircleButton, Button } from "_c/button";
import PlusIcon from "_c/icon/Plus";
import { requiredMixin } from "@/styles/mixins";
import { useSelector } from "react-redux";
import TextInput from "_c/form/TextInput";
import Empty from "_c/Empty";
import isempty from "lodash/isEmpty";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { ServiceAPI } from "@/api/service";
import NetworkRequest from "_c/NetworkRequest";
import Label from "@/components/form/Label";
import FormSect from "@/components/form/Sect";

const TitleSelect = ({
  isDisabled,
  t,
  value,
  onChange,
  onBlur,
  spec,
  ns,
  allowCreation,
}) => {
  const [isOpen, toggle] = useToggle();
  const onSelect = (title) => {
    onChange(title);
    toggle();
  };
  return (
    <>
      <FormSect
        onClick={toggle}
        role="button"
        onBlur={onBlur}
        style={{
          pointerEvents: isDisabled ? "none" : "auto",
          opacity: isDisabled ? 0.5 : 1,
        }}
        css={`
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          color: var(--font-color-main);
          font-weight: 500;
        `}
      >
        <CircleButton as="div" greenish>
          <PlusIcon color="white" />
        </CircleButton>
        {value ? (
          <span
            css={`
              margin-inline-start: 10px;
            `}
          >
            {value}
          </span>
        ) : (
          <span
            css={`
              margin-inline-start: 10px;
              ${requiredMixin};
            `}
          >
            {t(`${ns}.title_label`)}
          </span>
        )}
      </FormSect>
      <Label htmlFor="service-title-input">{t(`${ns}.title_label`)}</Label>
      <TextInput
        id="service-title-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Modal
        css={`
          height: 100%;
        `}
        isOpen={isOpen}
        onClose={toggle}
      >
        <Header onClick={toggle}>{t("common:close")}</Header>
        <Content>
          <TitleModal
            allowCreation={allowCreation}
            ns={ns}
            spec={spec}
            onSelect={onSelect}
            t={t}
          />
        </Content>
      </Modal>
    </>
  );
};
const selector = (data) =>
  data.map(({ title }) => ({
    value: title,
    label: title,
  }));
const defaultValue = [];
const TitleModal = (props) => {
  const locale = useSelector(UserSelectors.getLocale);
  const [search, setSearch] = useState("");
  const loader = useCallback(() => {
    return ServiceAPI.getTitleCompletion({
      title: search,
      locale,
      spec: props.spec,
    });
  }, [props.spec, locale, search]);
  return (
    <div
      css={`
        color: var(--font-color-main);
        input {
          margin-bottom: 15px;
        }
      `}
    >
      <TextInput
        value={search}
        autoFocus
        onChange={(e) => setSearch(e.target.value)}
        placeholder={props.t(`${props.ns}.title_placeholder`)}
      />
      <NetworkRequest
        isEnabled={Boolean(search)}
        defaultValue={defaultValue}
        defaultLoadingState="idle"
        loader={loader}
        select={selector}
      >
        {({ data }) => (
          <>
            {isempty(data) ? (
              <>
                {search.length <= 2 || !props.allowCreation ? (
                  <Empty message={props.t("common:empty")} />
                ) : (
                  <Button onClick={() => props.onSelect(search)} greenish small>
                    {props.t("common:create_some", { name: search })}
                  </Button>
                )}
              </>
            ) : (
              <ul>
                {data.map((title) => (
                  <li
                    onClick={() => props.onSelect(title?.label)}
                    role="button"
                    css={`
                      background-color: var(--bg-elevate);
                      padding: 10px;
                      cursor: pointer;
                      margin-bottom: 7px;
                      border-radius: 9px;
                    `}
                    key={title.value}
                  >
                    {title.label}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </NetworkRequest>
    </div>
  );
};
export default TitleSelect;
